import React, {Component} from "react";
import MustBeAdmin from "../../components/Must/MustBeAdmin.jsx";
import FreelanceList from "../../../shared/components/FreelanceList/FreelanceList.jsx";
import conf from "../../conf.js";
import {generate} from "../../routes.js";
import DefaultLayout from "../Layout/DefaultLayout.jsx";
import FreelancePageWrapper from "../../../shared/components/Styled/Containers/FreelancePageWrapper.jsx";

class FreelanceListContainers extends Component {
  render() {
    return(
      <DefaultLayout className="freelance-list-layout">
        <FreelancePageWrapper hideLevel2Btn={true}>
          <FreelanceList conf={conf} generate={generate}/>
        </FreelancePageWrapper>
      </DefaultLayout>)
  }
}

export default MustBeAdmin(FreelanceListContainers)